<template>

  <div>
    <v-container v-if="insureType === 'searchPlot'">
      <v-toolbar-items class="toolbar-items-container">
        <v-combobox v-model="personName" :items="persons" :loading="searchLoading" :search-input.sync="searchQuery"
          label="姓名" color="grey darken-1" :rules="[v => !!v || '姓名不能为空']" class="flex-grow-1 mr-4"
          :item-text="formatPersonDisplay" clearable @update:search-input="searchPersons"
          @change="onPersonSelected"></v-combobox>
        <v-select v-model="searchCrop" :items="authorizedCrops" item-text="text" item-value="value" label="险种" clearable
          color="grey darken-1" class="mr-4" style="max-width: 150px;"></v-select>
        <v-text-field v-model="calculatedTotalArea" label="总面积(亩)" readonly color="grey darken-1" class="mr-4"
          style="max-width: 100px;"></v-text-field>
        <v-btn @click="selectPlot" color="primary" class="flex-grow-0 mr-8">查询</v-btn>
      </v-toolbar-items>
      <!-- 添加表格组件 - 会自动包含从地图选择的地块 -->
      <v-data-table ref="plotDataTable" :headers="headers" :items="combinedLandData" :items-per-page="-1" class="mt-2"
        :loading="loading" loading-text="加载中..." no-data-text="暂无数据" show-select dense v-model="selected" item-key="id"
        fixed-header hide-default-footer :item-class="isInsuredClass" @toggle-select-all="handleSelectAll">
        <template v-slot:item.match="{ item }">
          <span :class="getMatchClass(item.match)">{{ formatMatch(item.match) }}</span>
        </template>
        <template v-slot:item.is_insured="{ item }">
          <span v-if="isInsured(item)" class="insured-status">是</span>
          <span v-else>否</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-btn small color="primary" class="mr-2" @click="viewSelectedLand(item)">
              查看
            </v-btn>
            <v-btn x-small color="error" v-if="isFromMap(item)" @click="removeLandPlot(item)">
              移除
            </v-btn>
          </div>
        </template>
        <template v-slot:item.area_mu="{ item }">
          {{ Number(item.area_mu).toFixed(2) }}
        </template>
      </v-data-table>
    </v-container>
    <v-container v-if="insureType === 'markedPlot'">
      <v-row dense>
        <v-col cols="12">
          <v-text-field v-model="area" label="面积(亩)" readonly color="grey darken-1" dense></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-text-field v-model="parcelName" label="地块名称" color="grey darken-1" :rules="[v => !!v || '地块名称不能为空']"
            dense></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-combobox v-model="ownerName" :items="ownerPersons" :loading="ownerSearchLoading"
            :search-input.sync="ownerSearchQuery" label="所属人姓名" color="grey darken-1" :rules="[v => !!v || '所属人姓名不能为空']"
            clearable @update:search-input="searchOwners" @change="handleOwnerChange" @click:clear="clearOwnerId"
            item-text="name"></v-combobox>
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="ownerId" label="所属人身份证号" color="grey darken-1"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn @click="createLand">提交</v-btn>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar" class="centered-snackbar">
      {{ notifyText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="indigo" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog ref="createPolicyDialog" v-model="policyDialog" persistent max-width="90%">
      <v-card>
        <v-card-title class="text-subtitle-1 pb-2">
          投保信息
        </v-card-title>
        <v-form class="px-6" ref="policyForm">
          <!-- 投保时间 -->
          <v-row dense>
            <v-col cols="3">
              <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field dense v-model="policyForm.policy_start_date" label="起保日期" prepend-icon="mdi-calendar"
                    readonly v-bind="attrs" v-on="on" :rules="[v => !!v || '请选择起保日期']"></v-text-field>
                </template>
                <v-date-picker v-model="policyForm.policy_start_date" @input="menu = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-text-field dense :value="selectedArea?.address?.name" label="所属地区" readonly></v-text-field>
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="3">
            </v-col>
          </v-row>
          <!-- 地块信息表格 -->
          <div class="text-subtitle-1 mb-1">地块信息</div>
          <v-row dense>
            <v-col cols="2">
              合计：
            </v-col>
            <v-col cols="4">
              地块数量: {{ selected.length }}块
            </v-col>
            <v-col cols="4">
              地块面积: {{ totalArea }}亩
            </v-col>
            <v-col cols="2">
              <v-btn icon x-small @click="showDetails = !showDetails" :title="showDetails ? '收起明细' : '展开明细'">
                <v-icon>{{ showDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-simple-table dense class="mb-2" v-if="showDetails">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>地块ID</th>
                  <th>地块名称</th>
                  <th>所属人</th>
                  <th>面积（亩）</th>
                </tr>
              </thead>
              <tbody>
                <template>
                  <tr v-for="item in selected" :key="item.land_id">
                    <td>{{ item.land_id }}</td>
                    <td>{{ item.land_name }}</td>
                    <td>{{ item.ownerName }}</td>
                    <td>{{ item.area_mu }}</td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>

          <!-- 投保人信息部分 -->
          <div class="text-subtitle-1 mt-2 mb-1">投保人信息</div>
          <v-row dense>
            <v-col cols="3">
              <v-text-field dense v-model="policyForm.holderName" label="被保险人姓名"
                :rules="[v => !!v || '请输入被保险人姓名']"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field dense v-model="policyForm.holderId" label="身份证号"
                :rules="idCardValidationRules"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field dense v-model="policyForm.phone_number" label="联系电话"></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field dense v-model="policyForm.bankcard" label="银行卡号"></v-text-field>
            </v-col>
          </v-row>

          <!-- 作物信息部分 -->
          <div class="text-subtitle-1 mt-2 mb-1">保险险种</div>
          <v-row dense>
            <v-col cols="6">
              <v-select dense label="险种信息" v-model="policyForm.crop_id" :items="authorizedCrops" item-text="text"
                item-value="value" :rules="[v => !!v || '请选择险种']"></v-select>
            </v-col>
            <v-col cols="6">
            </v-col>
          </v-row>
        </v-form>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="cancelPolicy">
            取消
          </v-btn>
          <v-btn color="green darken-1" text @click="policyConfirm">
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LineStringGeom from 'ol/geom/LineString';
import Option from '../../const/Option.js';
import { WFS_INS_PLOT_INSURED_URL } from '../../const/const.js';
import axios from '@/axios';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { GeoJSON } from 'ol/format';
import { Fill, Stroke, Style } from 'ol/style';
import { Mapable } from '../../mixins/Mapable';
import { mapState, mapMutations, mapGetters } from 'vuex';
import { idCardRules } from '../../util/Validate.js';

const EMPTY_RESULT_TEXT = ' -- ';

export default {
  name: 'ks-policy-result',
  mixins: [Mapable],
  props: {
    measureGeom: { type: Object },
    insureType: { type: String },
    trusteeLands: { type: Array }
  },
  data () {
    return {
      idCardValidationRules: idCardRules(), // Call the function to get the rules array
      area: EMPTY_RESULT_TEXT,
      distance: EMPTY_RESULT_TEXT,
      angle: EMPTY_RESULT_TEXT,
      personName: '',
      searchCrop: null,
      ownerName: '',
      ownerId: '',
      polygon: null,
      snackbar: false,
      notifyText: '',
      headers: [
        { text: '地块ID', value: 'land_id' },
        { text: '地块名称', value: 'land_name' },
        { text: '面积(亩)', value: 'area_mu' },
        { text: '作物', value: 'crop_name' },
        { text: '操作', value: 'actions' }
      ],
      landData: [], // Current search results
      persistentSelections: [], // Track explicitly selected items across searches
      loading: false,
      selected: [],
      showMapSelection: false,
      singleSelect: false,
      policyDialog: false,
      menu: false,
      option: Option,
      policyForm: {
        holderName: null,
        holderId: null,
        crop_id: null,
        phone_number: null,
        bankcard: null,
        policy_start_date: new Date().toISOString().substr(0, 10), // Set today as default
        mature_days: null
      },
      selectedVectorSource: new VectorSource(),
      polygonStyleFunction: () => {
        return new Style({
          stroke: new Stroke({
            color: '#FF0000',
            width: 2
          }),
          fill: new Fill({
            color: 'rgba(255, 0, 0, 0.1)'
          })
        });
      },
      persons: [],
      searchQuery: null,
      searchLoading: false,
      searchTimeout: null,
      showDetails: false,
      ownerPersons: [],
      ownerSearchQuery: null,
      ownerSearchLoading: false,
      ownerSearchTimeout: null
    }
  },
  computed: {
    ...mapState(['selectedLandPlots', 'authorizedArea']),
    ...mapGetters(['getCodesByType']),
    authorizedCrops () {
      console.log('authorizedArea:', this.authorizedArea);
      // First try to get crops from authorizedArea.results
      if (this.authorizedArea && this.authorizedArea?.length > 0) {
        return this.getCodesByType(this.authorizedArea[0].organize);
      }
      // Fallback to the original getCodesByType method
      return this.getCodesByType('CROP');
    },
    selectedArea () {
      return this.$store.state.selectedArea;
    },
    totalArea () {
      return this.selected.reduce((sum, item) => sum + Number(item.area_mu), 0).toFixed(1);
    },
    // Modified combinedLandData to preserve selections
    combinedLandData () {
      // Start with current land data from search results
      const combined = [...this.landData];
      // Add persistently selected items that are not in current land data
      this.persistentSelections.forEach(plot => {
        const existingIndex = combined.findIndex(item => item.land_id === plot.land_id);
        if (existingIndex === -1) {
          // Mark plots from persistent selection
          combined.push({
            ...plot,
            isPersistent: true
          });
        }
      });

      // Add any map-selected plots that aren't already in combined array
      this.selectedLandPlots.forEach(plot => {
        const existingIndex = combined.findIndex(item => item.land_id === plot.land_id);
        if (existingIndex === -1) {
          // Mark plots from map for identification
          combined.push({
            ...plot,
            fromMap: true
          });
        }
      });
      return combined;
    },
    calculatedTotalArea () {
      return this.combinedLandData.reduce((sum, item) => sum + Number(item.area_mu), 0).toFixed(1);
    }
  },
  watch: {
    measureGeom () {
      const me = this;
      const geom = me.measureGeom.geom;
      let output;
      if (geom && this.insureType === 'markedPlot') {
        output = me.formatArea(geom);
        me.area = output;

        // perimeter of outer LinearRing of measure polygon
        me.distance = me.formatLength(new LineStringGeom(
          geom.getLinearRing(0).getCoordinates()
        ));
      } else if (geom && this.measureType === 'distance') {
        output = me.formatLength(geom);
        me.distance = output;
      } else if (geom && this.measureType === 'angle') {
        me.angle = me.formatAngle(geom);
      } else {
        me.area = EMPTY_RESULT_TEXT;
        me.distance = EMPTY_RESULT_TEXT;
        me.angle = EMPTY_RESULT_TEXT;
      }
    },
    selected (newVal, oldVal) {
      // Update persistentSelections when items are selected/deselected
      this.updatePersistentSelections();
      this.onSelectionChanged();
    },
    // Add watcher for selectedLandPlots to automatically select plots from map
    selectedLandPlots (newVal) {
      console.log('Land plots from map updated:', newVal);
      this.updateSelectedPlotsFromMap();
    },
    // When landData changes (new person search), ensure selections are preserved
    landData () {
      this.restoreSelections();
    }
  },
  methods: {
    resolveCropFilter () {
      if (!this.searchCrop) return '';
      const matched = this.authorizedCrops.find(item => String(item.value) === String(this.searchCrop));
      return matched ? matched.text : this.searchCrop;
    },
    ...mapMutations(['clearSelectedLandPlots']),

    async searchPersons (val) {
      if (!val || val.length < 1) return;
      console.log('selected area:', this.selectedArea);
      if (!this.selectedArea?.place_id) {
        this.notifyText = '请先选择区域';
        this.snackbar = true;
        return;
      }

      // Clear previous timeout
      if (this.searchTimeout) clearTimeout(this.searchTimeout);

      // Set new timeout
      this.searchTimeout = setTimeout(async () => {
        this.searchLoading = true;
        try {
          const response = await axios.get('/plots/persons', {
            params: {
              limit: 100,
              name: val,
              village_code: this.selectedArea?.place_id
            }
          });

          if (response.data && response.data.data) {
            this.persons = response.data.data;
          }
        } catch (error) {
          console.error('搜索人员失败:', error);
          this.notifyText = '搜索人员失败';
          this.snackbar = true;
        } finally {
          this.searchLoading = false;
        }
      }, 500); // 500ms debounce
    },

    selectPlot () {
      if (!this.personName || !this.personName.name) {
        this.notifyText = '请输入人员信息';
        this.snackbar = true;
        return;
      }

      // Use the selected person's name for the search
      this.searchPlots(this.personName);
    },
    /**
   * Handles the selection of a person from the dropdown
   * @param {Object} selectedPerson - The selected person object
   */
    onPersonSelected (selectedPerson) {
      if (selectedPerson && selectedPerson.name) {
        // Reset data but don't reset selections
        this.landData = [];
        // Don't reset selections here: this.selected = [];
        // Use the selected person's name for the search immediately
        this.searchPlots(selectedPerson);
      }
    },

    /**
     * Searches for plots based on the provided person's name.     * @param {string} personName - The name of the person to search plots for.
     * @returns {Promise<void>}
     */
    async searchPlots (person) {
      this.loading = true;
      try {
        const response = await axios.post('/policies/person-policies', {
          id_number: person.id_number,
          village_code: this.selectedArea?.address?.place_id,
          crop_id: this.resolveCropFilter(),
          page: 1,
          page_size: 500
        });

        if (response.data && response.data.items) {
          // Store previous selections before updating landData

          // Update landData with new search results
          this.landData = response.data.items;
          // After landData is updated, restore selections based on land_id
        } else {
          this.landData = [];
        }
        // Locate the lands if plot data is found
        if (this.landData.length > 0) {
          this.locateLand(this.landData.map(item => item.land_id));
        }
      } catch (error) {
        console.error('查询失败:', error);
        this.notifyText = '查询失败';
        this.snackbar = true;
        this.landData = [];
      } finally {
        this.loading = false;
      }
    },
    onSelectionChanged () {
      console.log('Selected items:', this.selected);
      // Update the selected array based on the current selection
      // Handle selection change here
    },

    async refresh () {
      // Implement refresh logic for dependent dropdowns if needed
    },
    async viewSelectedLand (item) {
      // Extract the land ID from a single item and call locateLand with an array containing this ID
      const landId = item.land_id;
      if (landId) {
        await this.locateLand([landId]);
      } else {
        this.notifyText = '地块ID不存在';
        this.snackbar = true;
      }
    },
    async locateLand (landIds) {
      const self = this;
      try {
        if (!landIds || landIds.length === 0) {
          throw new Error('未提供地块ID');
        }

        // 构建地块ID的查询条件
        const idFilter = landIds.map(id => `land_id='${id}'`).join(' OR ');
        // 构建 WFS 请求URL
        const wfsUrl = new URL(WFS_INS_PLOT_INSURED_URL);
        wfsUrl.searchParams.append('service', 'WFS');
        wfsUrl.searchParams.append('version', '2.0.0');
        wfsUrl.searchParams.append('request', 'GetFeature');
        wfsUrl.searchParams.append('typeName', 'ins:ins_plot_insured');
        wfsUrl.searchParams.append('outputFormat', 'application/json');
        wfsUrl.searchParams.append('cql_filter', idFilter);

        // 发送 WFS 请求
        const response = await fetch(wfsUrl);
        const featureCollection = await response.json();

        if (!featureCollection.features?.length) {
          throw new Error('未找到地块数据');
        }

        // 创建矢量要素
        const format = new GeoJSON();
        const features = featureCollection.features.map(feature => {
          // Add name property to feature properties for labeling or identification
          if (feature.properties && feature.properties.land_name) {
            feature.properties.name = feature.properties.land_name;
          }
          return format.readFeature(feature, {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:4326'
          });
        });

        // 更新矢量图层
        this.selectedVectorSource.clear();
        features.forEach(feature => this.selectedVectorSource.addFeature(feature));

        // 获取或创建高亮图层
        let highlightLayer = self.map.getLayers().getArray()
          .find(layer => layer.get('lid') === 'activeParcelLayer');

        if (!highlightLayer) {
          // 如果图层不存在，创建新图层
          highlightLayer = new VectorLayer({
            source: this.selectedVectorSource,
            style: this.polygonStyleFunction,
            zIndex: 100
          });
          highlightLayer.set('lid', 'activeParcelLayer');
          self.map.addLayer(highlightLayer);
        } else {
          // 如果图层存在，更新其属性
          highlightLayer.setVisible(false);
          highlightLayer.setSource(this.selectedVectorSource);
          highlightLayer.setStyle(this.polygonStyleFunction);
          highlightLayer.setVisible(true);
        }

        // 计算所有地块的总范围
        const extent = this.selectedVectorSource.getExtent();
        this.map.getView().fit(extent, {
          padding: [300, 300, 300, 300],
          duration: 1000
        });
      } catch (error) {
        console.error('获取地块数据失败:', error);
        this.notifyText = '获取地块信息失败';
        this.snackbar = true;
      }
    },
    // Add method to remove a land plot from the Vuex store selection
    removeLandPlot (item) {
      // Remove from Vuex store
      const updatedPlots = this.selectedLandPlots.filter(plot => plot.land_id !== item.land_id);
      this.$store.commit('clearSelectedLandPlots');
      updatedPlots.forEach(plot => {
        this.$store.commit('addSelectedLandPlot', plot);
      });
      // Remove from selected array
      const selectedIndex = this.selected.findIndex(selected => selected.land_id === item.land_id);
      if (selectedIndex !== -1) {
        this.selected.splice(selectedIndex, 1);
      }
      // Also remove from persistent selections
      const persistentIndex = this.persistentSelections.findIndex(
        persisted => persisted.land_id === item.land_id
      );
      if (persistentIndex !== -1) {
        this.persistentSelections.splice(persistentIndex, 1);
      }
      this.notifyText = '已从列表中移除地块';
      this.snackbar = true;
    },
    // Check if an item came from the map
    isFromMap (item) {
      return item.fromMap === true;
    },
    // Update selections when map plots change
    updateSelectedPlotsFromMap () {
      // Ensure all map-selected plots are also in the selected array
      this.selectedLandPlots.forEach(plot => {
        // Skip insured plots
        if (this.isInsured(plot)) return;

        const existingIndex = this.selected.findIndex(item => item.land_id === plot.land_id);
        if (existingIndex === -1) {
          // Add to selected
          this.selected.push({
            ...plot,
            fromMap: true
          });
          // Also add to persistent selections
          const existsInPersistent = this.persistentSelections.some(
            item => item.land_id === plot.land_id
          );
          if (!existsInPersistent) {
            this.persistentSelections.push({
              ...plot,
              fromMap: true
            });
          }
        }
      });
    },
    /**
     * Searches for owners based on name input
     * @param {string} val - Search query input
     */
    async searchOwners (val) {
      if (!val || val.length < 1) return;
      if (!this.selectedArea?.address?.place_id) {
        this.notifyText = '请先选择区域';
        this.snackbar = true;
        return;
      }

      // Clear previous timeout
      if (this.ownerSearchTimeout) clearTimeout(this.ownerSearchTimeout);

      // Set new timeout
      this.ownerSearchTimeout = setTimeout(async () => {
        this.ownerSearchLoading = true;
        try {
          const response = await axios.get('/plots/persons', {
            params: {
              limit: 100,
              name: val,
              village_code: this.selectedArea?.address?.place_id
            }
          });

          if (response.data && response.data.data) {
            this.ownerPersons = response.data.data;
          }
        } catch (error) {
          console.error('搜索人员失败:', error);
          this.notifyText = '搜索人员失败';
          this.snackbar = true;
        } finally {
          this.ownerSearchLoading = false;
        }
      }, 500); // 500ms debounce
    },

    /**
     * Handles changes in the owner selection
     * @param {Object|string} owner - Selected owner object or manually entered name
     */
    handleOwnerChange (owner) {
      // If selection is an object with id_number, fill in the ID field
      if (owner && typeof owner === 'object' && owner.id_number) {
        this.ownerId = owner.id_number;
        this.ownerName = owner.name;
      } else if (typeof owner === 'string') {
        // If it's manual input (string), keep it as is but don't change ID
        this.ownerName = owner;
      } else if (!owner) {
        // If owner is cleared, also clear the ID
        this.ownerId = '';
      }
    },

    /**
     * Clears the owner ID when the owner name is cleared
     */
    clearOwnerId () {
      this.ownerId = '';
    },
    // Update persistent selections when items are selected/deselected
    updatePersistentSelections () {
      // Create a new array using current selections, filtering out insured plots
      this.persistentSelections = [...this.selected].filter(item => !this.isInsured(item));
    },

    // Restore selections when land data changes
    restoreSelections () {
      // This function now handles the task of restoring selections from persistentSelections to selected
      const newSelected = [];
      // Find matching items in combinedLandData for each persistent selection
      this.persistentSelections.forEach(persistentItem => {
        const itemInCombined = this.combinedLandData.find(
          item => item.land_id === persistentItem.land_id
        );
        if (itemInCombined && !this.isInsured(itemInCombined)) {
          newSelected.push(itemInCombined);
        }
      });
      // Only update selected if we have matches to avoid clearing existing selections
      if (newSelected.length > 0) {
        this.selected = newSelected;
      }
    },
    formatPersonDisplay (item) {
      if (item && item.name) {
        if (item.id_number && item.id_number.length === 18) {
          return `${item.name} - *${item.id_number.slice(-6)}`;
        }
        return item.name;
      }
      return '';
    },
    /**
     * Formats the match field value to display text
     * @param {number|string} matchValue - the match value (1, 2, or 3)
     * @returns {string} - formatted text
     */
    formatMatch (matchValue) {
      if (matchValue === 1 || matchValue === '1') return '匹配';
      if (matchValue === 2 || matchValue === '2') return '部分';
      if (matchValue === 3 || matchValue === '3') return '不匹配';
      return '--';
    },
    /**
     * Returns the CSS class based on match value
     * @param {number|string} matchValue - the match value
     * @returns {string} - CSS class name
     */
    getMatchClass (matchValue) {
      if (matchValue === 1 || matchValue === '1') return 'match-success';
      if (matchValue === 2 || matchValue === '2') return 'match-partial';
      if (matchValue === 3 || matchValue === '3') return 'match-fail';
      return '';
    },
    /**
     * Checks if a plot is already insured
     * @param {Object} item - The plot item
     * @returns {boolean} - True if plot is insured
     */
    isInsured (item) {
      return item.is_insured === 1 || item.is_insured === '1';
    },

    /**
     * Returns CSS class for the row based on insured status
     * @param {Object} item - The plot item
     * @returns {string} - CSS class name or empty string
     */
    isInsuredClass (item) {
      // Only apply the class if the item is insured
      return this.isInsured(item) ? 'insured-row' : '';
    },

    /**
     * Handles the select all toggle event
     * @param {Object} props - Contains items and value properties
     */
    handleSelectAll ({ items, value }) {
      if (value) {
        // 当点击全选时，只选择未投保的地块
        this.selected = items.filter(item => !this.isInsured(item));
      } else {
        // 当取消全选时，清空选择
        this.selected = [];
      }
    }
  },
  mounted () {
    // When component is mounted, add any existing map selections to the selected array
    this.updateSelectedPlotsFromMap();
  }
}
</script>

<style scoped>
.measure-result {
  font-size: 14px;
  padding-left: 8px;
  padding-bottom: 8px;
}

.centered-snackbar {
  left: 50%;
  top: 4em;
  transform: translate(-50%, -50%);
}

.toolbar-items-container {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.v-data-table {
  margin-bottom: 10px;
  max-height: 75vh;
  overflow: hidden;
}

/* 确保表格内容区域可以滚动 */
.v-data-table ::v-deep .v-data-table__wrapper {
  max-height: calc(75vh - 48px);
  /* 减去表头的高度 */
  overflow-y: auto;
}

/* 减少表格单元格之间的间距 */
.v-data-table ::v-deep td {
  padding: 0 4px !important;
  height: 32px !important;
  font-size: 0.85rem !important;
}

/* 减少表头的间距和高度 */
.v-data-table ::v-deep th {
  padding: 0 4px !important;
  height: 36px !important;
  font-size: 0.875rem !important;
}

/* 减少操作列按钮的大小和间距 */
.v-data-table ::v-deep .v-btn.small {
  min-width: 50px !important;
  margin: 0 !important;
  padding: 0 4px !important;
}

/* 减少操作列中按钮之间的间距 */
.v-data-table ::v-deep .d-flex .mr-2 {
  margin-right: 2px !important;
}

/* 减少表格行高 */
.v-data-table ::v-deep .v-data-table__wrapper table tr {
  min-height: 32px !important;
}

/* 使表格内容更紧凑，移除多余边框间距 */
.v-data-table ::v-deep .v-data-table__wrapper table {
  border-spacing: 0;
  border-collapse: collapse;
}

/* 隐藏复选框列的多余空间 */
.v-data-table ::v-deep .v-data-table__checkbox {
  width: 28px !important;
  padding: 0 2px !important;
}

.info-panel {
  background-color: #e3f2fd;
  border-radius: 4px;
}

/* 匹配状态样式 */
.match-success {
  color: green;
  font-weight: 500;
}

.match-partial {
  color: orange;
  font-weight: 500;
}

.match-fail {
  color: red;
  font-weight: 500;
}

/* 已投保状态样式 */
.insured-status {
  color: #1976d2;
  font-weight: 500;
}

/* 已投保行样式 - 只针对复选框禁用点击 */
.v-data-table ::v-deep .insured-row .v-data-table__checkbox {
  pointer-events: none;
  opacity: 0.5;
}

/* 已投保行中的复选框样式 */
.v-data-table ::v-deep .insured-row .v-input--selection-controls {
  opacity: 0.5;
}

/* 确保已投保行中的按钮保持可点击状态 */
.v-data-table ::v-deep .insured-row .d-flex {
  pointer-events: auto;
}
</style>
